<template>
  <v-app>
    <div v-if="!loading">
      <Drawer @toggleMenu="toggleMenu" :drawerIsOpen="drawerIsOpen" />
      <theme-header @toggleMenu="toggleMenu">
        <template slot="app">
          <v-main class="app">
            <router-view />
          </v-main>
        </template>
      </theme-header>
      <close-app-footer v-if="showFooter" />
    </div>
    <v-progress-circular v-else :size="200" color="green" class="progress" indeterminate></v-progress-circular>
  </v-app>
</template>

<script>
import ThemeHeader from "@/components/ThemeHeader.vue"
import { isRtlLang } from "./i18n"
import Drawer from "@/components/Drawer.vue"
import CloseAppFooter from "@/layouts/CloseAppFooter"
import { onReadyStateChange } from "@/helpers/generics"
export default {
  name: "App",
  components: {
    CloseAppFooter,
    ThemeHeader,
    Drawer,
  },
  data() {
    return {
      drawerIsOpen: false,
      loading: true,
    }
  },
  computed: {
    snackbar() {
      return this.$store.getters.snackbar
    },
    showFooter() {
      return false
    },
    showDrawer() {
      return this.$route.name !== "Login"
    },
  },
  methods: {
    toggleMenu(v) {
      this.drawerIsOpen = v
    },
  },
  async mounted() {
    await this.$store.dispatch("area/index")
    await this.$store.dispatch("point/index")
  },
  watch: {
    "$i18n.locale": function (newLocale) {
      this.$vuetify.rtl = isRtlLang(newLocale)
    },
  },
  created() {
    onReadyStateChange(this)
  },
}
</script>
<style lang="scss" scoped>
// ::v-deep.v-application.v-application.v-application--is-rtl.theme--light {
//   font-family: "Rubik", sans-serif !important;
// }

// font family for all app
.v-application {
  [class*="text-"] {
    font-family: "Rubik", sans-serif !important;
  }
  font-family: "Rubik",
  sans-serif !important;
}
.app {
  border-radius: 15px 15px 0px 0px !important;
  background-color: white !important;
}
.progress {
  margin: 50% auto;
}
</style>
